import { ReligionsschluesselEnum } from '../v2024';

export const ReligionsschluesselEnumLabels = {
    NichtKirchensteuerpflichtig: '11' as ReligionsschluesselEnum,
    RoemischKatholisch: '03' as ReligionsschluesselEnum,
    Evangelisch: '02' as ReligionsschluesselEnum,
    EvangelischReformiert: '05' as ReligionsschluesselEnum,
    EvangelischReformierteKircheBueckeburg: '20' as ReligionsschluesselEnum,
    EvangelischReformierteKircheStadthagen: '21' as ReligionsschluesselEnum,
    FranzoesischReformiert: '07' as ReligionsschluesselEnum,
    FreieReligionsgemeinschaftAlzey: '16' as ReligionsschluesselEnum,
    FreireligioeseLandesgemeindeBaden: '13' as ReligionsschluesselEnum,
    FreireligioeseLandesgemeindePfalz: '14' as ReligionsschluesselEnum,
    FreireligioeseGemeindeMainz: '15' as ReligionsschluesselEnum,
    FreireligioeseGemeindeOffenbach: '17' as ReligionsschluesselEnum,
    IsraelitischeReligionsgemeinschaftBaden: '25' as ReligionsschluesselEnum,
    JuedischeGemeindenLandesverbandHessen: '19' as ReligionsschluesselEnum,
    LandesverbandIsraelitischenKultusgemeindenBayern: '26' as ReligionsschluesselEnum,
    JuedischeGemeindeFrankfurtHessen: '18' as ReligionsschluesselEnum,
    JuedischeKultusgemeindenBadKreuznachKoblenz: '27' as ReligionsschluesselEnum,
    IsraelitischSaarland: '28' as ReligionsschluesselEnum,
    IsraelitischeReligionsgemeinschaftWuerttemberg: '12' as ReligionsschluesselEnum,
    NordrheinWestfalenIsraelitisch: '29' as ReligionsschluesselEnum,
    JuedischeGemeindeHamburg: '24' as ReligionsschluesselEnum,
    Altkatholisch: '04' as ReligionsschluesselEnum,
    Sonstige: '10' as ReligionsschluesselEnum
};
